var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUp = function SvgUp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.415 8.85 3.826-4.464a1 1 0 0 1 1.518 0l3.826 4.463a1 1 0 0 1-.76 1.651h-7.65a1 1 0 0 1-.76-1.65Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUp);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuNDE0OTYgOC44NDkyMUw2LjI0MDc0IDQuMzg1OEM2LjYzOTg0IDMuOTIwMTkgNy4zNjAxNiAzLjkyMDE5IDcuNzU5MjYgNC4zODU4TDExLjU4NSA4Ljg0OTIxQzEyLjE0MSA5LjQ5Nzg4IDExLjY4MDEgMTAuNSAxMC44MjU4IDEwLjVIMy4xNzQyMkMyLjMxOTg3IDEwLjUgMS44NTg5NiA5LjQ5Nzg4IDIuNDE0OTYgOC44NDkyMVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";